import { render, staticRenderFns } from "./res-label.vue?vue&type=template&id=72ad8694&scoped=true&"
import script from "./res-label.vue?vue&type=script&lang=js&"
export * from "./res-label.vue?vue&type=script&lang=js&"
import style0 from "./res-label.vue?vue&type=style&index=0&id=72ad8694&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72ad8694",
  null
  
)

export default component.exports